var map = {
	"./icon_01.png": "./src/assets/images/menu/icon_01.png",
	"./icon_02.png": "./src/assets/images/menu/icon_02.png",
	"./icon_03.png": "./src/assets/images/menu/icon_03.png",
	"./icon_04.png": "./src/assets/images/menu/icon_04.png",
	"./icon_05.png": "./src/assets/images/menu/icon_05.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/menu sync recursive ^\\.\\/icon_0.*\\.png$";